import * as Sentry from "@sentry/react"

// Imported first in index.js, so errors from the very first render are caught too.
// Only production builds (NODE_ENV "production", i.e. `npm run build`) report: anywhere else the
// DSN is empty, which turns the SDK into a no-op, and logs stay off.
const isProduction = process.env.NODE_ENV === "production"

Sentry.init({
    dsn: isProduction ? "https://5925554cc5b2c965329c42ab9ceb26a8@statiq-sentry.statiq.co.in/3" : "",
    // Must match the release the source maps are uploaded under
    release: process.env.REACT_APP_VERSION,
    environment: process.env.REACT_APP_ENV,
    // Adds request headers and IP for users:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    enableLogs: isProduction,
    // Share of page loads / navigations traced
    tracesSampleRate: 1.0,
    // Requests that get sentry-trace / baggage headers. Same-origin only for now: adding the API
    // base URL here makes every API call send those headers, which fails CORS unless the backend
    // allows them.
    tracePropagationTargets: [/^\//],
    // Replay 10% of sessions, and every session that hits an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
})
